(() => {
  const forms = new Map();
  const products = new Map();

  function setLabel(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  function update(form, state) {
    const script = form.querySelector('[data-cart-button-data]');
    if (script && state.source !== script.textContent) {
      try {
        state.data = JSON.parse(script.textContent);
        state.source = script.textContent;
      } catch {
        return;
      }
    }
    if (!state.data) state.data = products.get(form.dataset.productid);
    if (!state.data) return;
    const data = state.data;
    const values = new FormData(form);
    const variantId = values.get('id');
    const variant = data.variants.find((item) => String(item.id) === String(variantId));
    if (!variant) return;
    const planId = values.get('selling_plan');
    const allocation = variant.allocations.find((item) => String(item.id) === String(planId));
    const price = allocation ? allocation.price : variant.price;
    const originalPrice = Math.max(variant.compareAtPrice || variant.price, allocation?.compareAtPrice || 0);
    const percent = originalPrice > price && originalPrice > 0
      ? Math.round((originalPrice - price) * 100 / originalPrice)
      : 0;
    const label = !variant.available ? data.soldOut
      : percent > 0 ? data.discountLabel.replace('__PERCENT__', String(percent)) : data.label;
    const root = form.closest('[data-replo-product-container]') || form;
    const selector = root === form ? '[data-cart-button-label]'
      : '[data-cart-button-label], a[role="button"]:not([href]) p';
    root.querySelectorAll(selector).forEach((element) => setLabel(element, label));
    const section = form.closest('.shopify-section');
    section?.querySelectorAll('sticky-add-to-cart').forEach((sticky) => {
      if (sticky.dataset.productId === String(data.productId)) {
        setLabel(sticky.querySelector('[data-cart-button-label]'), label);
      }
    });
  }

  function scan(root) {
    const scripts = root.querySelectorAll?.('[data-cart-button-data]') || [];
    for (const script of scripts) {
      try {
        const data = JSON.parse(script.textContent);
        products.set(String(data.productId), data);
      } catch {
        continue;
      }
      const form = script.closest('form');
      if (!form || forms.has(form)) continue;
      const state = {};
      forms.set(form, state);
      update(form, state);
    }
    const reploForms = [...(root.querySelectorAll?.('[data-replo-product-container] form[action*="/cart/add"]') || [])];
    if (root.matches?.('form[action*="/cart/add"]') && root.closest('[data-replo-product-container]')) {
      reploForms.push(root);
    }
    for (const form of reploForms) {
      if (forms.has(form) || !products.has(form.dataset.productid)) continue;
      const state = {};
      forms.set(form, state);
      update(form, state);
    }
  }

  function refresh() {
    if (document.hidden) return;
    for (const [form, state] of forms) {
      if (form.isConnected) update(form, state);
      else forms.delete(form);
    }
  }

  scan(document);
  document.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches('[data-cart-button-data]')) scan(node.parentElement);
        else scan(node);
      }
    }
    refresh();
  }).observe(document.body, { childList: true, subtree: true });
  window.setInterval(refresh, 500);
})();
